import React, { useReducer, useCallback } from "react"
import {
  EVENTS,
  MACHINE,
  QUESTIONS,
  CORRECT_ANSWERS,
  DISCOUNT_CODES,
} from "./machine"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Card from "react-bootstrap/Card"
import Button from "react-bootstrap/Button"
import "./App.css"

function App() {
  const delayedDispatch = useCallback((event) => {
    setTimeout(() => {
      dispatch({
        event,
      })
    }, 1000)
  }, [])

  const InputReducer = (current, { event, value }) => {
    const { state } = current
    console.log("CURRENT STATE", state)
    const newState = MACHINE?.states[state]?.on[event]
    console.log("NEW STATE", newState)
    if (newState) {
      switch (event) {
        case EVENTS.RESET: {
          return {
            step: 1,
            answers: [],
            state: MACHINE.initial,
          }
        }
        case EVENTS.ANSWER:
          delayedDispatch(EVENTS.ANIMATION_DONE)
          return {
            ...current,
            state: newState,
            answers: [...current.answers, value],
          }
        case EVENTS.ANIMATION_DONE: {
          delayedDispatch(EVENTS.NEW_STEP_LOADED)
          return {
            ...current,
            step: current.step + 1,
            state: newState,
          }
        }
        case EVENTS.NEW_STEP_LOADED: {
          return {
            ...current,
            state: newState,
          }
        }
        default:
          console.log("NO CHANGE")
      }
    }
    return current
  }
  const [current, dispatch] = useReducer(InputReducer, {
    step: 1,
    answers: [],
    state: MACHINE.initial,
  })

  const runValidation = () => {
    const noOfCorrectAnswers = CORRECT_ANSWERS.filter(
      (answer, index) => answer === current.answers[index]
    ).length
    return (
      <>
        <p>{`${noOfCorrectAnswers}/${CORRECT_ANSWERS.length} rätt`}</p>
        <p>{DISCOUNT_CODES[noOfCorrectAnswers]?.text}</p>
        <p>{DISCOUNT_CODES[noOfCorrectAnswers]?.code}</p>
        <p>
          <small>
            <i>{DISCOUNT_CODES[noOfCorrectAnswers]?.validTo}</i>
          </small>
        </p>
        {noOfCorrectAnswers < 6 && (
          <Button
            variant='danger'
            onClick={() => {
              dispatch({ event: EVENTS.RESET })
            }}
          >
            Försök igen
          </Button>
        )}
      </>
    )
  }

  return (
    <Container>
      <div className='App-header'>
        <span className={current.state}>
          <Row>
            <Col>
              <Card
                style={{
                  backgroundColor: "transparent",
                  border: "3px solid white",
                  borderRadius: 0,
                  padding: "30px",
                }}
              >
                <Card.Body>
                  {current.step <= CORRECT_ANSWERS.length && (
                    <Card.Title>Fråga: {current.step}</Card.Title>
                  )}
                  <Card.Text>{QUESTIONS[current.step].question}</Card.Text>
                  <Row>
                    {QUESTIONS[current.step].answers.map((answer) => (
                      <Col key={answer.value} xs={12} sm={4} md={4} lg={4}>
                        <Button
                          block
                          variant='light'
                          onClick={() => {
                            console.log("DISPATCHING", {
                              event: EVENTS.ANSWER,
                              value: answer.value,
                            })
                            dispatch({
                              event: EVENTS.ANSWER,
                              value: answer.value,
                            })
                          }}
                          style={{
                            marginBottom: "5px",
                          }}
                        >
                          {answer.text}
                        </Button>
                      </Col>
                    ))}
                  </Row>
                  {QUESTIONS[current.step]?.lastStep && runValidation()}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </span>
      </div>
    </Container>
  )
}

export default App
